import React, { useState } from 'react';
import { signOut } from 'firebase/auth';
import { auth } from '../firebase';

const UserProfile = ({ user, onSignOut }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleSignOut = async () => {
    try {
      await signOut(auth);
      onSignOut();
    } catch (error) {
      console.error('Sign out error:', error);
    }
  };

  const getDisplayName = () => {
    if (user.displayName) {
      return user.displayName;
    }
    if (user.email) {
      return user.email.split('@')[0];
    }
    if (user.isAnonymous) {
      return 'Guest User';
    }
    return 'User';
  };

  const getAvatarUrl = () => {
    if (user.photoURL) {
      return user.photoURL;
    }
    return null;
  };

  const getProviderInfo = () => {
    if (user.isAnonymous) {
      return 'Anonymous';
    }
    if (user.providerData && user.providerData.length > 0) {
      const provider = user.providerData[0];
      switch (provider.providerId) {
        case 'google.com':
          return 'Google';
        case 'github.com':
          return 'GitHub';
        case 'password':
          return 'Email';
        default:
          return provider.providerId;
      }
    }
    return 'Unknown';
  };

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center space-x-2 text-sm font-medium text-gray-700 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 rounded-md p-2"
      >
        {getAvatarUrl() ? (
          <img
            className="h-8 w-8 rounded-full"
            src={getAvatarUrl()}
            alt={getDisplayName()}
          />
        ) : (
          <div className="h-8 w-8 rounded-full bg-gray-300 flex items-center justify-center">
            <svg className="h-5 w-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
            </svg>
          </div>
        )}
        <span className="hidden md:block">{getDisplayName()}</span>
        <svg className="h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>

      {isOpen && (
        <div className="absolute right-0 mt-2 w-56 bg-white rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none z-50">
          <div className="p-4 border-b border-gray-200">
            <div className="flex items-center space-x-3">
              {getAvatarUrl() ? (
                <img
                  className="h-10 w-10 rounded-full"
                  src={getAvatarUrl()}
                  alt={getDisplayName()}
                />
              ) : (
                <div className="h-10 w-10 rounded-full bg-gray-300 flex items-center justify-center">
                  <svg className="h-6 w-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                  </svg>
                </div>
              )}
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-gray-900 truncate">
                  {getDisplayName()}
                </p>
                {user.email && (
                  <p className="text-xs text-gray-500 truncate">
                    {user.email}
                  </p>
                )}
                <p className="text-xs text-gray-400">
                  Signed in with {getProviderInfo()}
                </p>
              </div>
            </div>
          </div>
          
          <div className="p-2">
            <button
              onClick={handleSignOut}
              className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 rounded-md transition-colors duration-200"
            >
              Sign out
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserProfile; 